import { createFileRoute } from "@tanstack/react-router";
import { SpokePage, buildSpokeHead, type SpokePageConfig } from "@/components/SpokePage";

const CONFIG: SpokePageConfig = {
  slug: "custom-home-builder-remodeler-marketing-colorado",
  metaTitle: "Custom Home Builder & Remodeler Marketing in Colorado",
  metaDescription: "Marketing for Colorado custom home builders and remodelers: portfolio websites from $1,850, local SEO and Google Maps from $950/month, month-to-month.",
  breadcrumbs: [{ label: "Home", to: "/" }],
  currentLabel: "Home Builder & Remodeler Marketing",
  eyebrow: "Custom Home Builders & Remodelers — Colorado",
  h1: (
    <>
      Custom Home Builder & <span className="text-brand-gold">Remodeler</span> Marketing in Colorado
    </>
  ),
  heroDescription: "Show your best work and get more requests for high-value builds and remodels.",
  intro: "Families planning a custom home, kitchen or basement spend weeks researching. We build a portfolio website, project pages and a Google Maps profile that earn their trust in Colorado Springs, Monument, Castle Rock, Parker and across the Front Range.",
  definition: { term: "Home builder and remodeler marketing", body: "Getting your homes and remodels in front of local homeowners when they search Google, Google Maps and AI tools." },
  whatWeDo: [
    { title: "Portfolio website", body: "Big photos, project stories and clear next steps." },
    { title: "Service pages", body: "Custom homes, additions, kitchens, baths and basements." },
    { title: "Town pages", body: "Pages for the communities where you build." },
    { title: "Google Maps", body: "Photos, reviews and services kept up to date." },
    { title: "AI search", body: "Answers about cost, timeline and process." },
    { title: "Clear pricing", body: "Websites from $1,850. Marketing from $950/mo." },
  ],
  whyThisMarket: [
    { heading: "Long research", body: "Homeowners compare builders for weeks before they call." },
    { heading: "Photos sell", body: "Your portfolio does most of the selling." },
    { heading: "Growing towns", body: "Monument, Castle Rock and Parker keep adding new neighborhoods." },
  ],
  relatedLinks: [
    { to: "/pricing", label: "Pricing" },
    { to: "/free-mockup", label: "Get a free website mockup" },
    { to: "/free-audit", label: "Get a free marketing audit" },
    { to: "/colorado-springs-headquarters", label: "Colorado Springs headquarters" },
    { to: "/web-design-castle-rock-colorado", label: "Castle Rock web design company" },
    { to: "/case-studies", label: "Colorado case studies" },
  ],
  faqs: [
    { q: "How much does it cost?", a: "Websites are $1,850 (Starter), $2,750 (Pro) or $5,950 (Expert), one-time, with one year of hosting and SSL. Monthly marketing is $950, $1,650 or $2,750 per month. Edits and repairs are $250/hour." },
    { q: "Do I have to sign a long contract?", a: "No. Monthly marketing is month-to-month." },
    { q: "Where are you located?", a: "Our office is at 3210 E Woodmen Rd STE 110, Colorado Springs, CO 80920. We serve businesses across Colorado." },
    { q: "How fast can my website be ready?", a: "Most websites are ready in under 7 business days." },
  ],
  serviceName: "Custom Home Builder and Remodeler Marketing in Colorado",
  serviceDescription: "Marketing for Colorado custom home builders and remodelers: portfolio websites from $1,850, local SEO and Google Maps from $950/month, month-to-month.",
  areaServed: "Colorado",
};

export const Route = createFileRoute("/custom-home-builder-remodeler-marketing-colorado")({
  head: () => buildSpokeHead(CONFIG),
  component: () => <SpokePage config={CONFIG} />,
});
